// components/LegalLayout.tsx

import { Outlet } from "@tanstack/react-router";

export default function LegalLayout() {
    return (
        <div className="min-h-screen bg-gray-50">
            <div className="border-b p-4 text-lg font-semibold">
                UNILinkd Legal
            </div>

            <main>
                <Outlet />
            </main>
        </div>
    );
}